export const getMuiAvatar = palette => ({
  colorDefault: {
    backgroundColor: palette.primary.main,
  },
})
